import FeatherIcon from "./FeatherIcon";

const LIST_STATUS = {
  Good: {
    icon: "check-circle",
    label: "Good length",
    tooltip: "This message will usually be delivered as one text message.",
    className: "good",
  },
  Long: {
    icon: "alert-triangle",
    label: "Long Message",
    tooltip:
      "Mobile carriers may split this into multiple messages. Please shorten it for more reliable delivery and to avoid additional texting costs.",
    className: "long",
  },
  "Very Long": {
    icon: "alert-circle",
    label: "Very long message",
    tooltip:
      "Mobile carriers may delay, split, or reject this message. Please shorten it for more reliable delivery and to avoid additional texting costs.",
    className: "very-long",
  },
};

const EDITOR_STATUS = {
  Good: {
    icon: "check-circle",
    label: "Good length",
    description: [
      "This message will usually be delivered as one text message.",
    ],
    className: "good",
  },
  Long: {
    icon: "alert-triangle",
    label: "Long Message",
    description: [
      "Mobile carriers may split this into multiple messages.",
      "Please shorten it for more reliable delivery and to avoid additional texting costs.",
    ],
    className: "long",
  },
  "Very Long": {
    icon: "alert-circle",
    label: "Very long message",
    description: [
      "Mobile carriers may delay, split, or reject this message.",
      "Please shorten this message for more reliable delivery and to avoid additional texting costs.",
    ],
    className: "very-long",
  },
};

export const MessageLengthListStatus = ({ status }) => {
  const content = LIST_STATUS[status] || LIST_STATUS.Good;

  return (
    <div
      className={`scheduler-message-length-badge ${content.className}`}
      uk-tooltip={content.tooltip}
      tabIndex="0"
      aria-label={`${content.label}. ${content.tooltip}`}
    >
      <FeatherIcon name={content.icon} />
      <span>{content.label}</span>
    </div>
  );
};

export const MessageLengthInlineStatus = ({ analysis }) => {
  if (!analysis?.messageCount) {
    return null;
  }

  const content = EDITOR_STATUS[analysis.status] || EDITOR_STATUS.Good;
  const tooltip = content.description.join(" ");

  return (
    <div
      className={`scheduler-message-length-inline ${content.className}`}
      uk-tooltip={tooltip}
      aria-label={`${content.label}. ${tooltip}`}
      aria-live="polite"
    >
      <FeatherIcon name={content.icon} />
      <strong>{content.label}</strong>
    </div>
  );
};

export const MessageLengthEditorStatus = ({ analysis }) => {
  const content = EDITOR_STATUS[analysis.status] || EDITOR_STATUS.Good;
  const showLengthGuidance = analysis.status !== "Good";
  const showSpecialCharacterWarning =
    analysis.specialCharacterWarningDetected && analysis.messageCount > 1;

  if (!showLengthGuidance && !showSpecialCharacterWarning) {
    return null;
  }

  return (
    <section className="scheduler-message-length-panel" aria-live="polite">
      {showLengthGuidance && (
        <div className={`scheduler-message-length-state ${content.className}`}>
          <div className="scheduler-message-length-title">
            <FeatherIcon name={content.icon} />
            <strong>{content.label}</strong>
          </div>
          {content.description.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      )}

      {showSpecialCharacterWarning && (
        <div
          className={`scheduler-special-character-warning ${
            showLengthGuidance ? "with-length-guidance" : ""
          }`}
        >
          <div className="scheduler-message-length-title">
            <FeatherIcon name="alert-triangle" />
            <strong>Special characters detected</strong>
          </div>
          <p>Some special characters increase the number of text messages sent.</p>
          <p>
            Examples include smart quotes, em dashes, ellipsis, and certain
            accented characters.
          </p>
        </div>
      )}
    </section>
  );
};
